import glamorous from "glamorous";
import { css } from "glamor";
import typography from "utils/typography";

// GLOBAL css rules
const TextContainer = glamorous.div({
  width: "100%",
  maxWidth: "40rem",
  margin: "0 auto",
  padding: "4rem 2rem",
  textAlign: "left",
});

const WideContainer = glamorous.div({
  width: `calc(100% - ${typography.rhythm(1)})`,
  maxWidth: "80rem",
  margin: `0 auto`,
  padding: "4rem 2rem",
  textAlign: "left",
  "@media(max-width: 48em)": {
    margin: "0 auto",
  },
});

const removePaddingVertical = css({
  paddingTop: 0,
  paddingBottom: 0,
});

const removePaddingTop = css({
  paddingTop: 0,
});

const removePaddingBottom = css({
  paddingBottom: 0,
});

const addMarginBottom = css({
  marginBottom: "2rem",
});

const removeMarginTop = css({
  marginTop: 0,
});

const removeMarginBottom = css({
  marginBottom: 0,
});

const removeMarginVertical = css({
  marginTop: 0,
  marginBottom: 0,
});

const removeMarginLeft = css({
  marginLeft: 0,
});

const addMarginSm = css({
  "@media(max-width: 48em)": {
    marginLeft: typography.rhythm(1),
    marginRight: typography.rhythm(1),
  },
});

const center = css({
  textAlign: "center",
  margin: "0 auto",
});

const Centered = glamorous.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const link = css({
  "&:hover": {
    textDecoration: "underline",
  },
});

const button = css({
  "&:hover": {
    cursor: "pointer",
  },
});

const underline = css({
  textDecoration: "underline",
});

const buttonStyle = css({
  display: "inline-block",
  background: "#e06b1c",
  color: "#ffffff",
  "&:hover": {
    background: "#e06b1c",
    color: "#ffffff",
    textDecoration: "underline",
  },
});

const shadowless = css({
  backgroundImage: "none",
  textShadow: "none",
});

const fillButton = css({
  whiteSpace: "nowrap",
  padding: `${typography.rhythm(0.5)} ${typography.rhythm(1)}`,
  lineHeight: typography.rhythm(1.5),
  "&:hover": {
    cursor: "pointer",
  },
});

const greenButton = css({
  color: "#fff",
  backgroundColor: "#769c3d",
  "&:hover": {
    backgroundColor: "#90bf4b",
  },
});

const greenButtonDisabled = css({
  pointerEvents: "none",
  filter: "grayscale(100%)",
  "&:hover": {
    backgroundColor: "#769c3d",
    pointerEvents: "none",
    cursor: "not-allowed",
  },
});

const blueButton = css({
  color: "#fff",
  backgroundColor: "#3142ba",
  "&:hover": {
    backgroundColor: "#3b50e2",
  },
});

const fullBleedBackground = css({
  minWidth: "100vw",
  minHeight: "100vh",
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
});

const hideOnSm = css({
  "@media(max-width: 47.997em)": {
    display: "none",
  },
});

const hideOnLg = css({
  "@media(min-width: 48em)": {
    display: "none",
  },
});

const wrapper = css({
  display: "flex",
  flexFlow: "wrap",
});

const fullWidth = css({
  flex: "1 0 100%",
});

const FullPageDiv = glamorous.div({
  width: "100%",
  height: "100vh",
  display: "grid",
  alignItems: "center",
  justifyContent: "center",
});

const halfWidth = css({
  flex: "1 0 100%",
  "@media(min-width: 48em)": {
    flex: "1 0 50%",
  },
});

const thirdWidth = css({
  flex: "1 0 33.333%",
});

const quarterWidth = css({
  flex: "1 0 25%",
});

const fullWidthSm = css({
  "@media(max-width: 48em)": {
    flex: "1 0 100%",
  },
});

const threeCols = css({
  display: "grid",
  gridTemplateColumns: "33% 33% 33%",
  alignItems: "center",
  "@media(max-width: 48em)": {
    gridTemplateColumns: "100%",
  },
});

const twoCols = css({
  display: "grid",
  gridTemplateColumns: "50% 50%",
});

const Grid2Cols = glamorous.div({
  display: "grid",
  gridTemplateColumns: "50% 50%",
  gridGap: "1rem",
});

const twoColsLg = css({
  display: "grid",
  "@media(min-width: 48em)": {
    gridTemplateColumns: "50% 50%",
  },
});

const twoColsSm = css({
  "@media(max-width: 48em)": {
    gridTemplateColumns: "50% 50%",
  },
});

const imageWrapper = css({
  marginBottom: typography.rhythm(1.5),
});

const bulletless = css({
  listStyleType: "none",
});

const grid = css({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridColumnGap: "0.5rem",
  gridRowGap: "0.5rem",
});

const verticalGrid = css({
  display: "grid",
  gridTemplateRows: "1fr 1fr",
  gridColumnGap: "0.5rem",
  gridRowGap: "0.5rem",
});

const inlineBlock = css({
  display: "inline-block",
});

const lead = css({
  fontSize: "1.4rem",
});

const hideVisually = css({
  border: "0 !important",
  clip: "rect(0 0 0 0) !important",
  height: "1px !important",
  margin: "-1px !important",
  overflow: "hidden !important",
  padding: "0 !important",
  position: "absolute !important",
  width: "1px !important",
  whiteSpace: "nowrap !important",
});

const blockquote = css({
  borderLeft: "1px solid #dedede",
});

const onWhite = css({
  background: "#ffffff",
});

export {
  TextContainer,
  WideContainer,
  addMarginBottom,
  removePaddingVertical,
  removePaddingTop,
  removePaddingBottom,
  removeMarginTop,
  removeMarginBottom,
  removeMarginVertical,
  removeMarginLeft,
  addMarginSm,
  center,
  link,
  shadowless,
  button,
  buttonStyle,
  fillButton,
  greenButton,
  greenButtonDisabled,
  blueButton,
  hideOnSm,
  hideOnLg,
  wrapper,
  fullWidth,
  FullPageDiv,
  halfWidth,
  thirdWidth,
  quarterWidth,
  fullWidthSm,
  imageWrapper,
  bulletless,
  grid,
  verticalGrid,
  Grid2Cols,
  inlineBlock,
  underline,
  lead,
  threeCols,
  hideVisually,
  blockquote,
  twoColsSm,
  twoColsLg,
  twoCols,
  onWhite,
  fullBleedBackground,
  Centered,
};
